
import moment from 'moment';
import url from 'url';
import Const from '@/constants';


const isProductive = (obj, stati) => {
	const currentdatetime = moment();
	const publishdatetime = moment(obj.TS_online_Liveserver, Const.DATETIMEFORMAT);
	const offlinedatetime = moment(obj.TS_offline_Liveserver, Const.DATETIMEFORMAT);

	let isInTimespan = false;

	if (publishdatetime.isValid() && currentdatetime.isAfter(publishdatetime)) {
		isInTimespan = true;

		if (offlinedatetime.isValid()) {
			/* Ist offliendatetime kein valides Datum, liefert isBetween 'false' zurück */
			if (currentdatetime.isBetween(publishdatetime, offlinedatetime)) {
				isInTimespan = true;
			} else {
				isInTimespan = false;
			}
		}
	}

	return obj.FKM_Status !== stati.entwurf && isInTimespan;
};

const isOffline = (obj) => {
	const currentdatetime = moment();
	const offlinedatetime = moment(obj.TS_offline_Liveserver, Const.DATETIMEFORMAT);

	return offlinedatetime.isValid() && currentdatetime.isAfter(offlinedatetime);
};

const isBeforeProduction = (obj) => {
	const currentdatetime = moment();
	const onlinedatetime = moment(obj.TS_online_Liveserver, Const.DATETIMEFORMAT);

	return onlinedatetime.isValid() && currentdatetime.isBefore(onlinedatetime);
};

const langifyUrl = (objUrl, currentLang) => (objUrl || '').replace('/de/', `/${currentLang}/`);


const onlineUrl = (obj, currentLang) => {
	const urlObject = langifyUrl(obj.S_URL_Objekt, currentLang);
	return (urlObject &&
	       urlObject.length > 0 &&
	       url.resolve(process.env.ERCO_SERVER, urlObject)) || '';
};


const previewUrl = (obj, currentLang) => {
	const urlObject = langifyUrl(obj.S_URL_Objekt, currentLang);
	return (urlObject &&
	       urlObject.length > 0 &&
	       url.resolve(process.env.LS2014_SERVER, urlObject)) || '';
};

export default { isProductive, isOffline, isBeforeProduction, onlineUrl, previewUrl };



// WEBPACK FOOTER //
// ./src/helper/objectHelper.js